import React from "react";
import { Link } from "react-router-dom";
import { TrackOrderSection } from "./UserDetails";

// Public order-tracking page — reachable from the "Track Your Order" button in the
// confirmation email (e.g. /track?orderId=<id>). No login required so guests can track too.
const TrackOrder = () => (
  <div className="min-h-screen py-8 sm:py-12 px-4" style={{ background: "linear-gradient(180deg,var(--brand-primary-50) 0%,#f9fafb 100%)" }}>
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-xl sm:text-2xl font-extrabold text-gray-800">Order Tracking</h1>
          <p className="text-sm text-gray-500 mt-0.5">Check the real-time status of your order.</p>
        </div>
        <Link to="/home" className="text-sm font-semibold text-[var(--brand-primary-700)] hover:text-[var(--brand-primary-900)] whitespace-nowrap">
          ← Continue shopping
        </Link>
      </div>
      <TrackOrderSection />
    </div>
  </div>
);

export default TrackOrder;
